import { useCallback } from 'react';

import { useHistory } from 'react-router-dom';

import { type CiaLaneView } from '@m/types/api';
import { CiaNearbyGateSheet } from 'apps/customer/components/GateAccess/CiaNearbyGateSheet';
import { useCiaNearbyGatePrompt } from 'apps/customer/hooks/useCiaNearbyGatePrompt';
import { gateAccessPath } from 'apps/customer/utils/gateAccessPath';

/**
 * App-level host for the nearby CIA gate prompt so it can surface on any customer
 * route, not just Home. The hook itself decides when a prompt is eligible.
 */
export function CiaNearbyGatePrompt() {
  const history = useHistory();
  const { dismiss, groups, isOpen, variant } = useCiaNearbyGatePrompt();

  const handleSelectLane = useCallback(
    (lane: CiaLaneView) => {
      dismiss();
      history.push(gateAccessPath(lane.ciaGateAccessUuid));
    },
    [dismiss, history],
  );

  return (
    <CiaNearbyGateSheet
      groups={groups}
      open={isOpen}
      onDismiss={dismiss}
      onSelectLane={handleSelectLane}
      variant={variant}
    />
  );
}
